import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const stats = [
  { value: '100K+', label: 'Tracks' },
  { value: '<10ms', label: 'Search' },
  { value: '6', label: 'Formats' },
  { value: '3', label: 'Platforms' },
];

export default function Stats() {
  const ref = useRef(null);
  const v = useInView(ref, { once: true, margin: '-40px' });

  return (
    <section data-testid="stats-section" ref={ref}>
      <div className="container stats-grid">
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            data-testid={`stat-${i}`}
            className="stats-item"
            initial={{ opacity: 0 }}
            animate={v ? { opacity: 1 } : {}}
            transition={{ duration: 0.6, delay: i * 0.08 }}
          >
            <div className="stat-value">{s.value}</div>
            <div className="stat-label">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
